module.exports = __webpack_public_path__ + "static/0045-562c51d8725faea8caa526febd6f3896.png";